(function () {
  if (window.addonWidgetInitialised) return;

  var widget = document.querySelector('.addon-widget[data-product-id]');
  if (!widget) return;

  window.addonWidgetInitialised = true;

  var productId   = widget.getAttribute('data-product-id');
  var formId      = widget.getAttribute('data-form-id');
  var moneyFormat = widget.getAttribute('data-money-format');
  var currency    = widget.getAttribute('data-currency');

  var textEl  = document.getElementById('addonSummaryText-'  + productId);
  var totalEl = document.getElementById('addonSummaryTotal-' + productId);

  /* ── Existing summary logic (unchanged) ── */
  widget.addEventListener('change', function (e) {
    if (e.target.classList.contains('addon-selector__checkbox')) {
      updateSummary();
    }
  }, { passive: true });

  function updateSummary() {
    var checkboxes = widget.querySelectorAll('input[name="addon_variant"]:checked');
    var count      = 0;
    var totalPrice = 0;
    var variants   = [];

    checkboxes.forEach(function (cb) {
      var price = parseFloat(cb.dataset.price);
      totalPrice += price;
      count++;
      variants.push({
        variantId : cb.value,
        title     : cb.dataset.title,
        price     : Math.round(price * 100)
      });
    });

    window.addonSelectedVariants            = window.addonSelectedVariants || {};
    window.addonSelectedVariants[productId] = variants;

    if (!textEl || !totalEl) return;

    if (count === 0) {
      textEl.textContent  = 'No add-ons selected';
      totalEl.textContent = '';
      return;
    }

    textEl.textContent  = count + ' add-on' + (count > 1 ? 's' : '') + ' selected';
    totalEl.textContent = '+' + formatMoney(Math.round(totalPrice * 100));
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  window.addonUpdateSummary = updateSummary;
  window.addonFormatMoney   = formatMoney;

  var CHECKED = 'input[name="addon_variant"]:checked:not(:disabled)';

  function hasAddons() {
    return !!widget.querySelector(CHECKED);
  }

  function selectedAddonItems() {
    var items = [];

    Array.prototype.forEach.call(widget.querySelectorAll(CHECKED), function (cb) {
      if (cb.value) items.push({ id: cb.value, quantity: 1 });
    });

    return items;
  }

  function clearSelection() {
    Array.prototype.forEach.call(widget.querySelectorAll(CHECKED), function (cb) {
      cb.checked = false;
    });

    updateSummary();
  }

  function productForm() {
    return formId ? document.getElementById(formId) : null;
  }

  function setError(message) {
    var form = productForm();
    var host = form && form.closest('product-form');
    var box = host && host.querySelector('.message-danger');

    if (message) console.error('[add-ons] ' + message);
    if (!box) return;

    box.classList.toggle('hidden', !message);
    box.textContent = message || '';
  }

  var SPINNER_SVG =
    '<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">' +
    '<circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>' +
    '</svg>';

  function setButtonLoading(button, state) {
    if (!button) return;

    if (state && !button.dataset.loading) {
      Array.prototype.forEach.call(button.children, function (child) {
        child.style.opacity = '0';
      });

      button.style.color = 'transparent';
      button.insertAdjacentHTML('beforeend', SPINNER_SVG);
      button.classList.add('pointer-events-none');
      button.dataset.loading = 'true';
      button.setAttribute('aria-loading', 'true');
      return;
    }

    if (!state && button.dataset.loading) {
      var spinner = button.querySelector('.spinner');
      if (spinner) spinner.remove();

      button.classList.remove('pointer-events-none');
      button.style.color = null;

      Array.prototype.forEach.call(button.children, function (child) {
        child.style.opacity = null;
      });

      delete button.dataset.loading;
      button.removeAttribute('aria-loading');
    }
  }

  function postToCart(items) {
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-bubble' }),
    }).then(function (response) {
      return response
        .json()
        .catch(function () { return null; })
        .then(function (data) {
          if (!response.ok || (data && data.status)) {
            throw new Error((data && (data.description || data.message)) || 'Unable to add to cart');
          }
          return data || {};
        });
    });
  }

  function refreshCart(data) {
    var bubble = document.getElementById('CartBubble');
    var section = data.sections && data.sections['cart-bubble'];

    if (bubble && section) {
      var count = String(section).match(/\d+/);
      if (count) {
        bubble.classList.remove('hidden');
        bubble.innerHTML = count[0];
      }
    }

    var first = data.items && data.items[0];

    document.dispatchEvent(
      new CustomEvent('product:added-to-cart', {
        detail: { id: first && (first.variant_id || first.id), quantity: first && first.quantity },
      })
    );

    var modal = document.querySelector('cart-modal');
    if (!modal || typeof modal.reloadContent !== 'function') return;

    return Promise.resolve(modal.reloadContent()).then(function () {
      modal.show();
    });
  }

  function addWithAddons(variantId, quantity, button) {
    var items = [{ id: variantId, quantity: quantity }].concat(selectedAddonItems());

    setError('');
    setButtonLoading(button, true);

    return postToCart(items)
      .then(function (data) {
        clearSelection();
        return refreshCart(data);
      })
      .catch(function (error) {
        setError(error.message);
      })
      .then(function () {
        setButtonLoading(button, false);
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var host = event.target.closest('sticky-add-to-cart quick-add-button');
      if (!host || !hasAddons()) return;

      var variantId = host.getAttribute('variant-id');
      if (!variantId) return;

      event.preventDefault();
      event.stopPropagation();

      addWithAddons(variantId, 1, host.querySelector('button'));
    },
    true
  );

  /* ── Mobile slider: <scroll-carousel> drives scrolling + arrows; we only sync dots ── */
  function initSlider() {
    var carousel = document.getElementById('addon-list-' + productId);
    var arrowBar = document.getElementById('addon-slider-arrows-' + productId);
    if (!carousel || !arrowBar) return;

    var dots  = Array.prototype.slice.call(arrowBar.querySelectorAll('[data-addon-dot]'));
    var items = Array.prototype.slice.call(carousel.querySelectorAll('.addon-item'));
    if (dots.length < 2) return;

    function syncDots() {
      var width = carousel.clientWidth;
      var index = width ? Math.round(carousel.scrollLeft / width) : 0;
      if (index < 0) index = 0;
      if (index > dots.length - 1) index = dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('active', i === index);
      }
    }

    function scrollToIndex(index) {
      var target = items[index];
      if (target && typeof carousel.goItem === 'function') {
        carousel.goItem(target);
      } else {
        carousel.scrollTo({ left: carousel.clientWidth * index, behavior: 'smooth' });
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        scrollToIndex(parseInt(dot.getAttribute('data-addon-dot'), 10) || 0);
      });
    });

    var syncTimer;
    carousel.addEventListener('scroll', function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(syncDots, 80);
    }, { passive: true });

    syncDots();
  }

  /* Init after DOM ready */
  function boot() {
    updateSummary();
    initSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }



})();